import { graphqlClient } from '@/lib/graphql-client';
import { buildGetLeaveCategoriesLookupQuery } from '../graphql/leave-lookups';

export interface LeaveCategoryOption {
  ItemId: string;
  Title: string;
  LeaveLimit: number;
  IsUnlimited?: boolean;
}

const LEAVE_CATEGORY_PAGE_SIZE = 100;

/**
 * Every leave category of the active organization, sorted by title (legacy `getLeaveTypes(region)`;
 * the organization now stands for the region).
 */
export const getLeaveCategoriesLookup = async (): Promise<LeaveCategoryOption[]> => {
  const result = await graphqlClient.query<{ LeaveCategorys: { items: LeaveCategoryOption[] } }>({
    query: buildGetLeaveCategoriesLookupQuery({}, 1, LEAVE_CATEGORY_PAGE_SIZE),
  });
  return [...result.LeaveCategorys.items].sort((a, b) => a.Title.localeCompare(b.Title));
};
